import React from "react";
import "./inner-shadow.scss";

class InnerShadowButton extends React.Component {
  render() {
    return (
      <button
        className={
          "inner-shadow-btn p-0  " + (!this.props.active && " outlined")
        }
        onClick={e => {
          e.preventDefault();
          this.props.clicked(e);
        }}
        color="primary"
        size="lg"
      >
        {this.props.title ? this.props.title : "Button"}
      </button>
    );
  }
}

export default InnerShadowButton;
